import Flags from "../components/Flags";
import SearchAndFilter from "../components/SearchAndFilter";

function Homepage() {
  return (
    <main>
      <SearchAndFilter />
      <Flags />
    </main>
  );
}

export default Homepage;
